export const CHECKOUT_BREAKDOWN = "Checkout breakdown";
export const SUBTOTAL = "Subtotal";
export const PACKAGE_SAVINGS = "Package savings";
export const SEAT_SELECTION = "Seat selection";
export const TOTAL_DUE_TODAY = "Total due today";
export const HOTEL_SERVICE_FEE = "Hotel service fee";
export const DUE_AT_CHECKIN = "Due at check-in";
export const MANDATORY_TAXES = "Mandatory taxes";
export const MANDATORY_FEES = "Mandatory fees";
export const RESORT_FEES = "Resort fees";
